import { render, staticRenderFns } from "./Macro.vue?vue&type=template&id=53b50eec&scoped=true"
import script from "./Macro.vue?vue&type=script&lang=js"
export * from "./Macro.vue?vue&type=script&lang=js"
import style0 from "./Macro.vue?vue&type=style&index=0&id=53b50eec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53b50eec",
  null
  
)

export default component.exports